import { useTranslation } from 'react-i18next';
import { RxDragHandleDots2 } from 'react-icons/rx';
import { IoChevronDown } from 'react-icons/io5';
import { OutgoingSectionDto } from 'api/dtos/events/products';
import { useDeleteSectionMutation } from 'legacy/events/hooks';
import EditSectionButton from './components/EditSectionButton';

interface SectionHeaderProps {
  section: OutgoingSectionDto;
  isEditing: boolean;
  isExpanded: boolean;
  sectionName: string;
  tierCount: number;
  onToggleSection: () => void;
  onNameChange: (name: string) => void;
  onNameBlur: () => Promise<void>;
  onDeleteSection: () => void;
  onEditSection: () => void;
  onCancelEdit: () => void;
  deleteMutation: ReturnType<typeof useDeleteSectionMutation>;
  inputRef: React.RefObject<HTMLInputElement>;
}

export const SectionHeader = ({
  section,
  isEditing,
  isExpanded,
  sectionName,
  tierCount,
  onToggleSection,
  onNameChange,
  onNameBlur,
  onDeleteSection,
  onEditSection,
  onCancelEdit,
  deleteMutation,
  inputRef
}: SectionHeaderProps) => {
  const { t } = useTranslation(['events']);
  
  return (
    <div className="flex items-center">
      <div>
        <RxDragHandleDots2
          size={25}
          className="cursor-grab text-[#787878]"
        />
      </div>
      
      {isEditing ? (
        <div className="flex items-center flex-1">
          <input
            ref={inputRef}
            placeholder={t('events:pricingTiers.categories.newCategoryPlaceholder')}
            value={sectionName}
            onChange={(e) => onNameChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                onNameBlur();
              } else if (e.key === 'Escape') {
                e.preventDefault();
                onCancelEdit();
              }
            }}
            className="text-xl font-medium text-gray-500 border rounded px-2 py-1 flex-1"
          />
          <div className="flex items-center">
            <EditSectionButton
              section={section}
              onDelete={onDeleteSection}
              deleteMutation={deleteMutation}
              editSection={onEditSection}
              handleNameBlur={onNameBlur}
              isSelected={isEditing}
            />
          </div>
        </div>
      ) : (
        <div
          className="flex items-center justify-between cursor-pointer py-6 pr-4 pl-2 flex-1"
          onClick={onToggleSection}
        >
          <p className="text-lg font-medium text-black">
            {sectionName}
            {tierCount > 0 && (
              <span className="text-gray-600"> ({tierCount})</span>
            )}
          </p>
          <div className="flex items-center">
            <EditSectionButton
              section={section}
              onDelete={onDeleteSection}
              deleteMutation={deleteMutation}
              editSection={onEditSection}
              handleNameBlur={onNameBlur}
              isSelected={isEditing}
            />
            <IoChevronDown
              size={24}
              className={`ml-2 text-black transition-transform duration-200 ${
                isExpanded ? '' : 'transform rotate-180'
              }`}
            />
          </div>
        </div>
      )}
    </div>
  );
}; 